import { render, staticRenderFns } from "./pitching.vue?vue&type=template&id=06024c6c&scoped=true&"
import script from "./pitching.vue?vue&type=script&lang=js&"
export * from "./pitching.vue?vue&type=script&lang=js&"
import style0 from "./pitching.vue?vue&type=style&index=0&id=06024c6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06024c6c",
  null
  
)

export default component.exports